var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarbell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 475.87 475.87",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M465.87,226.507h-7.637v-28.495c0-10.203-8.301-18.503-18.503-18.503h-17.513c-2.612-7.054-9.388-12.104-17.339-12.104 h-17.845c-10.202,0-18.503,8.3-18.503,18.503v40.6H107.335v-40.6c0-10.203-8.301-18.503-18.503-18.503H70.986 c-7.951,0-14.726,5.051-17.339,12.104H36.136c-10.202,0-18.503,8.301-18.503,18.503v28.495H10c-5.522,0-10,4.477-10,10 s4.478,10,10,10h7.633v31.351c0,10.203,8.301,18.503,18.503,18.503h17.512c2.612,7.054,9.388,12.105,17.339,12.105h17.846 c10.202,0,18.503-8.3,18.503-18.503v-43.456h261.196v43.456c0,10.203,8.301,18.503,18.503,18.503h17.845 c7.951,0,14.727-5.051,17.339-12.105h17.513c10.202,0,18.503-8.3,18.503-18.503v-31.351h7.637c5.522,0,10-4.477,10-10 S471.393,226.507,465.87,226.507z M37.633,199.509h14.851v76.852H37.633V199.509z M72.483,288.466v-10.608v-79.846v-10.608h14.852 v101.061H72.483z M403.382,288.466h-14.851V187.404h14.851v10.607v79.846V288.466z M423.382,276.361v-76.852h14.852v76.852H423.382z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarbell);
export default __webpack_public_path__ + "static/media/barbell.2b2bf1e1e73a97d4e4d8f86a50c6ca5c.svg";
export { ForwardRef as ReactComponent };